module.exports = __webpack_public_path__ + "./docs/img/messaging.92da7cd4092beb52770fc3a5ff563871.svg";